import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { SupplierMapping } from '@synergy/models';

import { Attribute } from '../../../../../../common/models/attribute';
import {
    CLEAR_SUPPLIER_ATTRIBUTE_MAPPINGS,
    RECEIVE_SUPPLIER_ATTRIBUTE_MAPPING,
    RECEIVE_SUPPLIER_ATTRIBUTE_MAPPINGS,
} from './supplier-attribute-mapping-actions';

export interface SupplierAttributeMappingReducerState {
    supplierMappings: PaginatedResponse<SupplierMapping<Attribute>>;
}

export const initialAttributesReducerState: SupplierAttributeMappingReducerState = {
    supplierMappings: { items: [], limit: 10, page: 0, total: 0 },
};

export const supplierAttributeMappingReducer = (
    state: SupplierAttributeMappingReducerState = initialAttributesReducerState,
    action: AnyAction
): SupplierAttributeMappingReducerState => {
    const { type, ...rest } = action;

    switch (type) {
        case RECEIVE_SUPPLIER_ATTRIBUTE_MAPPING: {
            const items = [...state.supplierMappings.items];
            const index = items.findIndex(mapping => mapping.id === rest['supplierMapping'].id);
            if (index >= 0) {
                items[index] = rest['supplierMapping'];
            }

            return {
                ...state,
                supplierMappings: { ...state.supplierMappings, items },
            };
        }

        case RECEIVE_SUPPLIER_ATTRIBUTE_MAPPINGS: {
            return {
                ...state,
                supplierMappings: rest['supplierMappings'],
            };
        }

        case CLEAR_SUPPLIER_ATTRIBUTE_MAPPINGS: {
            return {
                ...state,
                supplierMappings: { ...state.supplierMappings, items: [] },
            };
        }

        default: {
            return state;
        }
    }
};
